import React from 'react'
import { useStyles } from './styles'
import { useSelector } from 'react-redux'
import { RootState } from 'src/lib/store'
import { Typography, Divider, Grid } from '@material-ui/core'

export const RequestInfo: React.FC = () => {
  const classes = useStyles()
  const payloadState = useSelector((state: RootState) => state.payload.data)

  return (
    <>
      <Typography variant='h6' className={classes.subTitle}>
        Request Information
      </Typography>
      <Divider />
      <Grid container className={classes.infoGroup}>
        <Grid item xs={6} className={classes.row}>
          <Typography>Request Type:</Typography>
        </Grid>
        <Grid item xs={6} className={classes.row}>
          <Typography>{payloadState.requestType}</Typography>
        </Grid>
        {payloadState.relationshipType === 'Current or former member/applicant for SAFE products or services' && (
          <>
            <Grid item xs={6} className={classes.row}>
              <Typography>Account Type:</Typography>
            </Grid>
            <Grid item xs={6} className={classes.row}>
              <Typography>{payloadState.accountType}</Typography>
            </Grid>
          </>
        )}
        <Grid item xs={6} className={classes.row}>
          <Typography>Delivery Method:</Typography>
        </Grid>
        <Grid item xs={6} className={classes.row}>
          <Typography>{payloadState.onBehalf === 'Yes' ? payloadState.deliveryMethod : payloadState.deliveryMethod}</Typography>
        </Grid>
        <Grid item xs={6} className={classes.row}>
          <Typography>Relationship:</Typography>
        </Grid>
        <Grid item xs={6} className={classes.row}>
          <Typography>{payloadState.relationshipType}</Typography>
        </Grid>
      </Grid>
    </>
  )
}
